var map = {
	"./JAICP-hb.svg": 8726,
	"./favicon.ico": 6949,
	"./flags/en.svg": 4597,
	"./flags/ru.svg": 289,
	"./flags/zh.svg": 6190,
	"./jaicp_black_h.svg": 8704,
	"./main-page/about1.svg": 9163,
	"./main-page/about2.svg": 3404,
	"./main-page/about3.svg": 743,
	"./main-page/link1.svg": 4391,
	"./main-page/link2.svg": 3113,
	"./main-page/link3.svg": 1322,
	"./main-page/link4.svg": 4195,
	"./main-page/rocket.svg": 8212,
	"./page-404.svg": 8285
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7165;